import React, { useState, useEffect } from 'react';
import { getServices, getCategories } from '../services/pocketbase';
import './PriceList.css';

function PriceList() {
  const [categories, setCategories] = useState([]);
  const [groupedServices, setGroupedServices] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [cats, servs] = await Promise.all([getCategories(), getServices()]);

      // Organiser les services par catégorie
      const grouped = {};

      // Initialiser les groupes avec les catégories existantes
      cats.forEach(cat => {
        grouped[cat.id] = [];
      });
      grouped['uncategorized'] = [];

      // Remplir les groupes
      servs.forEach(service => {
        if (!service.active) return; // Ne pas afficher les inactifs

        const catId = service.category || 'uncategorized';
        if (!grouped[catId]) grouped[catId] = []; // Sécurité
        grouped[catId].push(service);
      });

      setCategories(cats);
      setGroupedServices(grouped);
    } catch (error) {
      console.error("Erreur chargement tarifs", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="tarifs" className="price-list-section">
        <div className="container" style={{ textAlign: 'center', padding: '3rem' }}>
          <p>Chargement des tarifs...</p>
        </div>
      </section>
    );
  }

  // Si aucune donnée n'est chargée (ex: DB vide), afficher un fallback ou vide
  if (categories.length === 0 && (!groupedServices['uncategorized'] || groupedServices['uncategorized'].length === 0)) {
    // Optionnel : remettre les données statiques en faillback ou juste un message
    return null;
  }
  return (
    <section id="tarifs" className="price-list-section">
      <div className="container">
        <h2 className="section-title">Nos Tarifs</h2>
        <p className="price-list-intro">
          Tarifs TTC.
          Un devis personnalisé peut être réalisé en salon selon la nature et la longueur de vos cheveux.
        </p>

        <div className="price-categories">
          {/* Catégories définies */}
          {categories.map(cat => {
            const catServices = groupedServices[cat.id] || [];
            if (catServices.length === 0) return null; // Ne pas afficher catégorie vide

            return (
              <div key={cat.id} className="price-category">
                <h3 className="price-category-title">{cat.name}</h3>
                {/* On pourrait ajouter un champ 'notes' ou 'description' à la catégorie en DB plus tard */}
                <ul className="price-items-list">
                  {catServices.sort((a, b) => (a.order || 0) - (b.order || 0)).map(item => (
                    <li key={item.id} className="price-item">
                      <div className="service-details">
                        <span className="service-name">{item.title}</span>
                        {item.description && <span className="service-notes">{item.description}</span>}
                      </div>
                      <span className="service-price">
                        {item.on_quote ? 'Sur devis' : (item.price > 0 ? `${item.price}€` : '')}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}

          {/* Services Non Catégorisés (s'il y en a) */}
          {groupedServices['uncategorized'] && groupedServices['uncategorized'].length > 0 && (
            <div className="price-category">
              <h3 className="price-category-title">Autres Prestations</h3>
              <ul className="price-items-list">
                {groupedServices['uncategorized'].map(item => (
                  <li key={item.id} className="price-item">
                    <div className="service-details">
                      <span className="service-name">{item.title}</span>
                      {item.description && <span className="service-notes">{item.description}</span>}
                    </div>
                    <span className="service-price">{item.on_quote ? 'Sur devis' : (item.price > 0 ? `${item.price}€` : '')}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <p className="price-list-footer-note">
          Pour toute question ou demande spécifique, n'hésitez pas à nous contacter.
        </p>

      </div>
    </section>
  );
}

export default PriceList;